import { State } from 'store'

export const getCategoryItems = (state: State) => state.categories.items
